import { Navigate, Outlet } from 'react-router';
import { useAuthStore } from '@/stores/authStore';
import { getAdminHomeRoute, isAdminRole, ROLES, ROUTES } from '@/lib/constants';

interface AdminRouteProps {
  allowedRoles?: number[];
}

export function AdminRoute({ allowedRoles = [ROLES.ADMIN] }: AdminRouteProps) {
  const { user } = useAuthStore();
  const roleId = Number(user?.roleId);

  if (!user) {
    return <Navigate to={ROUTES.LOGIN} replace />;
  }

  if (!isAdminRole(roleId)) {
    return <Navigate to={ROUTES.DASHBOARD} replace />;
  }

  if (!allowedRoles.includes(roleId)) {
    return <Navigate to={getAdminHomeRoute(roleId)} replace />;
  }

  return <Outlet />;
}
